import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const ManagersSvg: FC<Props> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={color ?? 'currentColor'}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6ZM5.5 7.5C7.15685 7.5 8.5 6.15685 8.5 4.5C8.5 2.84315 7.15685 1.5 5.5 1.5C3.84315 1.5 2.5 2.84315 2.5 4.5C2.5 6.15685 3.84315 7.5 5.5 7.5ZM2.47125 10.3859C1.69423 10.9255 1.5 11.4485 1.5 11.6923C1.5 12.1384 1.86162 12.5 2.30769 12.5H8.69231C9.13838 12.5 9.5 12.1384 9.5 11.6923C9.5 11.4485 9.30577 10.9255 8.52875 10.3859C7.79249 9.87456 6.71829 9.5 5.5 9.5C4.28171 9.5 3.20751 9.87456 2.47125 10.3859ZM0 11.6923C0 9.84615 2.475 8 5.5 8C6.68089 8 7.77796 8.28134 8.67669 8.7342C9.45014 8.28579 10.4333 8 11.5 8C13.975 8 16 9.53846 16 11.0769C16 12.139 15.139 13 14.0769 13H10.594C10.1778 13.604 9.4813 14 8.69231 14H2.30769C1.03319 14 0 12.9668 0 11.6923ZM10.9911 11.5H14.0769C14.3106 11.5 14.5 11.3106 14.5 11.0769C14.5 10.9743 14.4039 10.6048 13.8119 10.1861C13.2575 9.79397 12.437 9.5 11.5 9.5C10.9828 9.5 10.5012 9.58955 10.0802 9.73573C10.6064 10.2701 10.9342 10.8815 10.9911 11.5ZM12.5 5C12.5 5.55228 12.0523 6 11.5 6C10.9477 6 10.5 5.55228 10.5 5C10.5 4.44772 10.9477 4 11.5 4C12.0523 4 12.5 4.44772 12.5 5ZM14 5C14 6.38071 12.8807 7.5 11.5 7.5C10.1193 7.5 9 6.38071 9 5C9 3.61929 10.1193 2.5 11.5 2.5C12.8807 2.5 14 3.61929 14 5Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default ManagersSvg;
